module.exports = __webpack_public_path__ + "static/media/banner.7a191c52.webp";